import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateFrankliEmailClickDto } from '@app/models/create-frankli-email-click.dto';
import { Observable } from 'rxjs';

@Injectable()
export class EmailAPIService {
  private readonly BASE_URL: string = '/api/email';

  constructor(
    private http: HttpClient
  ) { }

  createClick(token: string): Observable<string> {
    const url = `${this.BASE_URL}/click`;

    const createFrankliEmailClickDto = new CreateFrankliEmailClickDto(token);

    // Tracking endpoint returns a plain-text token with 200 OK, not JSON.
    // Without responseType:'text', HttpClient tries to JSON.parse it and emits
    // an HttpErrorResponse despite the 200 (FRONTEND-3V5).
    return this.http.post(url, createFrankliEmailClickDto, { responseType: 'text' });
  }

  createAnonymousClick(token: string): Observable<string> {
    const url = `${this.BASE_URL}/click/anonymous`;

    const createFrankliEmailClickDto = new CreateFrankliEmailClickDto(token);

    // Tracking endpoint returns a plain-text token with 200 OK, not JSON.
    // Without responseType:'text', HttpClient tries to JSON.parse it and emits
    // an HttpErrorResponse despite the 200 (FRONTEND-3V5).
    return this.http.post(url, createFrankliEmailClickDto, { responseType: 'text' });
  }

}
